import { render } from "./Emoji.vue?vue&type=template&id=ff42d5d6&scoped=true"
const script = {}

import "./Emoji.vue?vue&type=style&index=0&id=ff42d5d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff42d5d6"]])

export default __exports__